import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { newTerritory, Territory } from '../models/territories';

interface State {
    territory: Territory,
}

const initialState: State = {
    territory: { ...newTerritory }
};

export const editTerritorySlice = createSlice({
    name: 'editTerritory',
    initialState,
    reducers: {
        update(state, action: PayloadAction<Partial<Territory>>) {
            state.territory = { ...state.territory, ...action.payload };
        },
    }
});
